<template>
    <div>
        <b-card>
            <div slot="header">
                <i class="fa fa-list-ul" aria-hidden="true"></i>
                    Privilege list
                <div class="card-header-actions">
                    <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
                    <small class="text-muted">docs</small>
                    </a>
                </div>
            </div>
            <b-row>
                <b-col sm="12">
                    <alert-fail :show="isError"> {{ errorMessage }} </alert-fail>
                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="currentPage"
                          :per-page="numberPerPage"
                          class="table-privilege"
                          tbody-class="tbody" hover
                          thead-tr-class="thead-news"
                          @row-clicked="viewDetails"
                          selectable
                          selectedVariant="single"
                          :fields="fields"
                          :items="list">
                          <template slot="thumbnail" slot-scope="row">
                            <img class="thumbnail" :src="row.item.thumbnail" alt="Wrong Data">
                          </template>
                          <template slot="active" slot-scope="row">
                              <font style="color: #f86c6b" v-if="row.item.active">Inactive</font>
                              <font style="color: #4dbd74" v-else>Active</font>
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                    <b-col>
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="numberPerPage"
                        class="my-0"
                        ></b-pagination>
                    </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import AlertFail from '../../components/alert/AlertFail';
import { timestampToDate } from '../../assets/utils/formatter';
export default {
  data () {
    return {
      isError: false,
      errorMessage: '',
      isBusy: false,
      currentPage: 1,
      numberPerPage: 20,
      fields: [
        { key: 'thumbnail' },
        { key: 'createdDate' },
        { key: 'name' },
        { key: 'active' }
      ],
      list: []
    };
  },
  methods: {
    viewDetails (e) {
      this.$router.push({ name: 'privilege-details', params: { id: e.id } });
    },
    errorHandler (error) {
      this.isError = true;
      this.errorMessage = error.response ? error.response.data : error.message;
    }
  },
  computed: {
    totalRows () {
      return this.list.length;
    }
  },
  mounted () {
    this.isBusy = true;
    this.axios.get(process.env.VUE_APP_URL_MQDC_API + '/privileges?show=all', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(response => {
        const data = response.data.data;
        const current = new Date();
        for (const privilege of data) {
          if (0 !== Object.keys(privilege).length) {
            this.list.push({
              id: privilege.id,
              thumbnail: privilege.thumbnail,
              createdDate: timestampToDate(privilege.createdAt.timestamp),
              name: privilege.name,
              active: current >= timestampToDate(privilege.duration.start.timestamp) &&
                    current <= timestampToDate(privilege.duration.end.timestampToDate)
            });
          }
        }
        this.isBusy = false;
      })
      .catch(error => {
        console.log(error);
        this.errorHandler(error);
      });
  },
  components: {
    AlertFail
  }
};
</script>

<style scoped>
    .table-privilege{
        color: #73818f;
    }
    .table-privilege>thead{
        font-size: 10px;
    }
    .thumbnail{
        max-width: 100px;
    }
</style>
